/*
 * Movimiento de las galerías de obras (colecciones, fotógrafos, especiales).
 * Se carga desde snippets/default-filter-assets.liquid. No toca facets.js ni load-more.js:
 * observa #ProductGridContainer y anima lo que ellos insertan (filtrar, ordenar, cargar más).
 *
 * - Entrada: las primeras 8 tarjetas las anima el CSS desde el primer pintado (fr-gallery.css);
 *   las demás, este script, al entrar en pantalla. Sin JS todo se ve normal.
 * - Al abrir una obra, su foto viaja a la página de la obra (transición de vista entre documentos).
 */
(function () {
  'use strict';

  var EASE = 'expo.out';
  var CARD = '.product-card';
  var IMG = '.image.is-product-card-image';
  // La tarjeta contiene el modal viejo (position: fixed): un transform en ella lo desanclaría de la pantalla.
  // Por eso la tarjeta solo cambia de opacidad y el movimiento va en el marco de la foto.
  var MASK = '.is-product-card-image-mask';
  var CSS_ENTRANCE = 8;          // tarjetas que anima el CSS al cargar (nth-child(-n+8) en fr-gallery.css)
  var SHARED_NAME = 'fr-art';    // mismo nombre que la foto de la obra v2 (assets/fr-product.css)

  // ---------- la foto de la tarjeta viaja a la página de la obra, y de regreso ----------
  function inView(el) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; }
  // arriving: al regresar a la galería la tarjeta puede estar aún en su entrada de CSS (opacidad 0);
  // se le salta la entrada para que la foto aterrice visible.
  function cardImgFor(url, arriving) {
    var path;
    try { path = new URL(url, location.href).pathname; } catch (e) { return null; }
    var links = document.querySelectorAll('#ProductGridContainer .card-link');
    for (var i = 0; i < links.length; i++) {
      if (links[i].pathname !== path) continue;
      var card = links[i].closest(CARD), img = card.querySelector(IMG);
      if (!img || !inView(img)) return null;
      if (arriving) { card.classList.add('fr-no-enter'); card.setAttribute('data-fr-seen', ''); return img; }
      return getComputedStyle(card).opacity !== '0' ? img : null;
    }
    return null;
  }
  function nameDuring(img, transition) {
    img.style.viewTransitionName = SHARED_NAME;
    transition.finished.finally(function () { img.style.viewTransitionName = ''; });
  }
  // Solo hay transición si la página de destino también la declara (hoy: la obra con plantilla v2).
  window.addEventListener('pageswap', function (e) {
    if (!e.viewTransition || !e.activation || !e.activation.entry) return;
    var img = cardImgFor(e.activation.entry.url);
    if (img) nameDuring(img, e.viewTransition);
  });
  window.addEventListener('pagereveal', function (e) {
    var from = window.navigation && navigation.activation && navigation.activation.from;
    if (!e.viewTransition || !from) return;
    var img = cardImgFor(from.url, true);
    if (img) nameDuring(img, e.viewTransition);
  });

  function init() {
    var gsap = window.gsap;
    var container = document.getElementById('ProductGridContainer');
    if (!gsap || !container || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // ---------- tarjetas: aparecen en grupos al entrar en pantalla ----------
    var io = new IntersectionObserver(function (entries) {
      var batch = entries.filter(function (e) { return e.isIntersecting; }).map(function (e) { return e.target; });
      if (!batch.length) return;
      batch.forEach(function (c) { io.unobserve(c); });
      var pick = function (sel) { return batch.map(function (c) { return c.querySelector(sel); }).filter(Boolean); };
      gsap.to(batch, { opacity: 1, duration: 0.7, ease: EASE, stagger: 0.07, clearProps: 'opacity' });
      gsap.to(pick(MASK), { y: 0, duration: 0.8, ease: EASE, stagger: 0.07, clearProps: 'transform' });
      gsap.to(pick(IMG), {
        scale: 1, duration: 1.1, ease: EASE, stagger: 0.07, clearProps: 'transform',
        onComplete: function () { batch.forEach(function (c) { c.classList.remove('fr-entering'); }); }
      });
    }, { rootMargin: '0px 0px -6% 0px' });

    function prepare(cards) {
      cards.forEach(function (card) {
        card.setAttribute('data-fr-seen', '');
        card.classList.add('fr-entering');   // sin transiciones CSS mientras manda GSAP
        gsap.set(card, { opacity: 0 });
        var mask = card.querySelector(MASK);
        if (mask) gsap.set(mask, { y: 24 });
        var img = card.querySelector(IMG);
        if (img) {
          gsap.set(img, { scale: 1.08 });
          // La foto que aún se descarga entra con fundido en lugar de pintarse de golpe.
          if (!img.complete) {
            img.classList.add('fr-img-pending');
            var done = function () { img.classList.remove('fr-img-pending'); };
            img.addEventListener('load', done, { once: true });
            img.addEventListener('error', done, { once: true });
          }
        }
        io.observe(card);
      });
    }
    function fresh() { return [].slice.call(container.querySelectorAll(CARD + ':not([data-fr-seen])')); }

    // ---------- contador "(24)": cuenta hasta el nuevo total al filtrar ----------
    var count = document.getElementById('ProductCount');
    // shown: el número en pantalla (también a mitad de una cuenta, si llega otro filtro).
    var countObserver = null, shown = count ? parseInt(count.textContent.replace(/\D/g, ''), 10) : NaN;
    function tweenCount() {
      var target = parseInt(count.textContent.replace(/\D/g, ''), 10);
      if (isNaN(target) || isNaN(shown) || target === shown) { shown = target; return; }
      var o = { n: shown };
      count.textContent = '(' + shown + ')';   // sin esto se vería un cuadro del número final antes de contar
      countObserver.takeRecords();
      gsap.to(o, {
        n: target, duration: 0.6, ease: EASE, overwrite: true,
        onUpdate: function () {
          shown = Math.round(o.n);
          count.textContent = '(' + shown + ')';
          countObserver.takeRecords();   // nuestros propios cambios no cuentan como filtrado nuevo
        }
      });
    }
    if (count) {
      countObserver = new MutationObserver(tweenCount);
      countObserver.observe(count, { childList: true, characterData: true, subtree: true });
    }

    // ---------- filtrar / ordenar / cargar más: facets.js y load-more.js reemplazan o agregan tarjetas ----------
    new MutationObserver(function () {
      var cards = fresh();
      if (!cards.length) return;
      // Desde aquí la entrada de CSS ya no aplica: las tarjetas nuevas las anima este script.
      document.documentElement.classList.add('fr-gallery-live');
      prepare(cards);
    }).observe(container, { childList: true, subtree: true });

    // Al cargar: las primeras 8 que están a la vista ya las anima el CSS. Las que están fuera de pantalla
    // quedan ocultas (el estilo en línea manda cuando termina su animación de CSS) hasta que entren.
    var initial = fresh();
    initial.forEach(function (card, i) {
      if (i < CSS_ENTRANCE && inView(card)) card.setAttribute('data-fr-seen', '');
    });
    prepare(fresh());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
